import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Button": Button, "@mui/material/List": List, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemText": ListItemText, "@mui/material/DialogTitle": DialogTitle, "@mui/material/DialogContent": DialogContent, "@mui/material/DialogActions": DialogActions, "@mui/material/Dialog": Dialog, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio, "@mui/material/FormControlLabel": FormControlLabel } } });
export default ClientProvider;
